export default "__VITE_ASSET__aeef0083__"